import { race, Pattern, takeLeading, takeLatest, StrictEffect } from 'redux-saga/effects';

import { IAction } from '../models/action';

export function takeLeadingUnless<TPayload>(
    pattern: Pattern<any>,
    saga: (action: IAction<TPayload>) => Generator<StrictEffect>,
    cancelEffects: any[],
) {
    return takeLeading(pattern, function* (action: IAction<TPayload>) {
        yield race([saga(action), ...cancelEffects]);
    });
}

export function takeLatestUnless<TPayload>(pattern: Pattern<any>, saga: (action: IAction<TPayload>) => Generator<any>, cancelEffects: any[]) {
    return takeLatest(pattern, function* (action: IAction<TPayload>) {
        yield race([saga(action), ...cancelEffects]);
    });
}
